var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {
  pluginRegistry.registerFeature("Octopus.Features.RedGateDatabase", function(busy, octopusRepository) {
    return {
      title: "Red Gate Database Deployment",
      description: "Deploy a database using SQLCI.exe from Red Gate",
      editTemplateUrl: "areas/projects/features/Octopus.Features.RedGateDatabase_edit.html",
      priority: 100,
      editLink: function($scope, element, action, step, project) {

      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.RedGateDatabase.Enabled"] = "True";
        action.Properties["Octopus.Action.RedGateDatabase.CompareOptions"] = "IgnoreUsers,IgnoreCertificatesAndCryptoKeys,ForceColumnOrder,ThrowOnFileParseFailed";
        action.Properties["Octopus.Action.RedGateDatabase.PostDeployValidationEnabled"] = "True";
        action.Properties["Octopus.Action.RedGateDatabase.SqlCiPath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\sqlCI.exe";
        action.Properties["Octopus.Action.RedGateDatabase.SqlComparePath"] = "C:\\Program Files (x86)\\Red Gate\\SQL Automation Pack 1\\sqlCI\\SC\\SQLCompare.exe";
      },
      validate: function(action, step, errors) {
        if (!action.Properties["Octopus.Action.RedGateDatabase.SqlCiPath"]) {
          errors.push("Please specify a path to SQLCI.exe.");
        }
        if (!action.Properties["Octopus.Action.RedGateDatabase.SqlComparePath"]) {
          errors.push("Please specify a path to SQLCompare.exe.");
        }
        if (!action.Properties["Octopus.Action.RedGateDatabase.ConnectionStrings"]) {
          errors.push("Please specify the connection strings to the databases that you wish to deploy.");
        }
      },
      disable: function(action, step) {
          Object.keys(action.Properties).filter(function(name) {
              return name.indexOf("Octopus.Action.RedGateDatabase.") === 0;
          }).forEach(function(name){
              delete action.Properties[name];
          });
      }
    };
  });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.RedGateDatabase.js
// module id = 563
// module chunks = 1